// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLightbulb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.128 4.11a6.34 6.34 0 0 1 .559 9.09c-.494.538-1.094.888-1.437 1.543-.23.441-.375.921-.428 1.416-.045.394.037.857-.179 1.1H9.308c-.168-.24-.096-.678-.113-.946a3.74 3.74 0 0 0-.236-1.11c-.295-.776-.806-1.17-1.372-1.715A6.343 6.343 0 0 1 13.1 2.681a6.34 6.34 0 0 1 3.028 1.428z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.146 19.252a2.16 2.16 0 0 1-4.32 0"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.466 19.45H8.54v-3.202h6.926zM8.54 17.99l6.926-.545"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m13.813 9.627-.757 6.621h-1.954l-.758-6.62a7.35 7.35 0 0 0 1.735.198 7.352 7.352 0 0 0 1.734-.199z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLightbulb;
